import ECLogo from '../../assets/ecochain.png';
import { FaRegUser } from 'react-icons/fa';
import { MdLockOutline } from 'react-icons/md';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    const user = { username, password };
    axios
      .post('/users/login', user)
      .then((res) => {
        if (res.status.toString().startsWith('2')) {
          setError('');
          setSuccess(res.data.message);
          window.location.reload();
        } else {
          setSuccess('');
          setError(res.data.message);
        }
        const token = res.data.token;
        localStorage.setItem('token', token);
      })
      .catch((err) => {
        setSuccess('');
        console.log(err);
        setError(err.response.data.message);
      });
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-[91.5vh] w-full flex-1 px-20 text-center bg-green-50">
      <div className="bg-white rounded-2xl shadow-2xl flex md:w-2/3 max-w-[80%]">
        <div className="w-3/5 p-5">
          <div className="text-left font-bold flex text-green-500">
            <img src={ECLogo} alt="EcoChain Logo" className="w-6 mr-1" />
            EcoChain
          </div>
          <div className="py-10 pb-5">
            <h2 className="text-3xl font-bold mb-2 text-green-500">Sign In</h2>

            <div className="border-2 w-10 border-green-500 inline-block mb-2"></div>
            {error && (
              <p className="text-red-500 text-xs text-left mt-2 bg-red-200 p-2 border-l-2 border-red-500 w-1/2 m-auto">
                {' '}
                X {error}
              </p>
            )}
            {success && (
              <p className="text-green-500 text-xs text-left mt-2 bg-green-200 p-2 border-l-2 border-green-500 w-1/2 m-auto">
                {' '}
                ✓ {success}
              </p>
            )}
          </div>
          <form onSubmit={handleSubmit}>
            <div className="flex flex-col items-center">
              <div className="bg-gray-100 w-3/6 p-2 flex items-center mb-3">
                <FaRegUser className="text-gray-400 m-2" />
                <input
                  type="text"
                  placeholder="Username"
                  className="bg-inherit outline-none w-full text-gray-600"
                  value={username || ''}
                  onChange={(e) => setUsername(e.target.value)}
                />
              </div>
              <div className="bg-gray-100 w-3/6 p-2 flex items-center mb-3">
                <MdLockOutline className="text-gray-400 m-2" />
                <input
                  type="password"
                  placeholder="Password"
                  className="bg-inherit outline-none w-full text-gray-600"
                  value={password || ''}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </div>
              <button className="border-2 text-green-500 border-green-500 rounded-full px-6 py-2 hover:bg-green-500 hover:text-white font-semibold mt-5">
                Sign In
              </button>
            </div>
          </form>
        </div>
        <div className="text-white w-2/5 py-36 px-12 bg-green-500 rounded-tr-2xl rounded-br-2xl">
          <h2 className="text-3xl font-bold mb-2">Sign Up</h2>
          <div className="border-2 w-10 border-white inline-block mb-2"></div>
          <p className="mb-6">
            Don't have an account yet? Create an account to get started.
          </p>
          <Link to="/signup">
            <button className="border-2 border-white rounded-full px-6 py-2 hover:bg-white hover:text-green-500 font-semibold">
              Create Account
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Login;
